// extracted by mini-css-extract-plugin
export var active = "_30-2";
export var errorDot = "_30-3";
export var sideNavContainer = "_30-0";
export var sideNavLink = "_30-1";